import ICareerBuilderEdgeAdvanceSearchDefault from '../types/ICareerBuilderEdgeAdvanceSearch';

export default {
  searchPattern: 'Any',
  AcademicDiscipline: [],
  JobTitle: [],
  CurrentEmployer: [],
  ContactInfo: [],
  CurrentlyEmployed: [],
  City: [],
  Country: [],
  DegreeLevel: [],
  Industry: [],
  HasResume: [],
  PreviousEmployer: [],
  Skill: [],
  Source: [],
  State: [],
  DesiredJobType: [],
  WorkStatus: [],
  zipcode: '',
  YearsOfExperience: [],
  jobTitle: '',
  EdgeScore: [],
  ResumeModified: [],
  SecurityClearance: [],
  WillingToRelocate: [],
} as ICareerBuilderEdgeAdvanceSearchDefault;
